<template>
  <div>
    <v-dialog
      :model-value="show"
      width="550"
      @update:model-value="close"
    >
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>
              {{ $t('buttons.return-call.cta') }}
            </v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <!-- TODO: check unsupported prop: dark -->
              <v-btn
                icon
                @click="close"
              >
                <v-icon size="large"> mdi-close </v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>

        <v-card-text class="mt-8 text-body-1 user-form">
          <div>
            <v-form
              ref="form"
              v-model="valid"
              name="return-call-reason"
            >
              <v-text-field
                v-model="returnCallReason"
                :label="$t('settings.features.return-call.labels.add')"
                variant="outlined"
                :rules="[rules.required]"
              />
            </v-form>
          </div>
        </v-card-text>

        <v-card-actions class="pb-4">
          <v-btn
            variant="text"
            @click="close"
          >
            {{ $t('labels.cancel') }}
          </v-btn>
          <v-spacer />

          <v-btn
            color="primary"
            class="px-4 mr-2 mb-2"
            :loading="loading"
            :disabled="loading"
            @click="submit"
          >
            {{ $t('labels.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from '@/lib/validation'

export default {
  props: {
    show: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      rules: { required },
      valid: false,
      returnCallReason: null,
    }
  },
  methods: {
    async close() {
      this.$refs.form.resetValidation()
      this.returnCallReason = null
      this.$emit('close')
    },
    async submit() {
      const { valid } = await this.$refs.form.validate()
      if (!valid) {
        return
      }
      this.createReturnCallReason()
    },
    createReturnCallReason() {
      this.$emit('addReason', this.returnCallReason)
    },
  },
  emits: ['close', 'addReason'],
}
</script>
